var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiversityOfSolution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(-288 -2075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 40,
    height: 40,
    transform: "translate(288 2075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "idea_2_",
    "data-name": "idea (2)",
    transform: "translate(292.166 2079.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(4.701 0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M84.751.26a11.127,11.127,0,0,0-5.932,18.27,7.228,7.228,0,0,1,1.829,4.736v1.856a2.788,2.788,0,0,0,1.923,2.647,4.627,4.627,0,0,0,9.143,0,2.788,2.788,0,0,0,1.923-2.647V23.267a7.324,7.324,0,0,1,1.883-4.8A11.135,11.135,0,0,0,84.751.26Zm2.392,29.563A2.839,2.839,0,0,1,84.518,27.9h5.249A2.839,2.839,0,0,1,87.142,29.823Zm4.639-4.7a.929.929,0,0,1-.928.928H83.431a.929.929,0,0,1-.928-.928v-.928h9.278Zm2.343-7.876a9.3,9.3,0,0,0-2.292,5.093h-9.38A9.169,9.169,0,0,0,80.206,17.3a9.278,9.278,0,1,1,13.919-.051Z",
    transform: "translate(-76.01 -0.012)",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 11.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M2.783,179.99H.928a.928.928,0,0,0,0,1.856H2.783a.928.928,0,0,0,0-1.856Z",
    transform: "translate(0 -179.99)",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0.272 4.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M7.289,80.967,5.977,79.655a.928.928,0,0,0-1.312,1.312l1.312,1.312a.928.928,0,0,0,1.312-1.312Z",
    transform: "translate(-4.394 -79.384)",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0.272 16.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M7.289,259.655a.928.928,0,0,0-1.312,0l-1.312,1.312a.928.928,0,0,0,1.312,1.312l1.312-1.312A.928.928,0,0,0,7.289,259.655Z",
    transform: "translate(-4.393 -259.383)",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(27.957 11.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M454.783,179.99h-1.856a.928.928,0,0,0,0,1.856h1.856a.928.928,0,0,0,0-1.856Z",
    transform: "translate(-452 -179.99)",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(28.229 4.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M459.289,79.655a.928.928,0,0,0-1.312,0l-1.312,1.312a.928.928,0,1,0,1.312,1.312l1.312-1.312A.928.928,0,0,0,459.289,79.655Z",
    transform: "translate(-456.393 -79.384)",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(28.229 16.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M459.289,260.967l-1.312-1.312a.928.928,0,1,0-1.312,1.312l1.312,1.312a.928.928,0,1,0,1.312-1.312Z",
    transform: "translate(-456.393 -259.383)",
    fill: "#4A4A4A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversityOfSolution);
export default __webpack_public_path__ + "static/media/diversity-of-solution.353bfcf93fc182fe4723413af30ef6d9.svg";
export { ForwardRef as ReactComponent };